import React from 'react';

export default function BlackChevronDown ({ className = '' } = {}) {
  return (
    <svg className={className} width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M5.37558 6.87274L0.187657 1.69533C-0.0625523 1.44563 -0.0625523 1.0408 0.187657 0.791129L0.792745 0.18727C1.04253 -0.0620051 1.44735 -0.0624848 1.69772 0.186204L5.82862 4.28939L9.95949 0.186204C10.2099 -0.0624848 10.6147 -0.0620051 10.8645 0.18727L11.4696 0.791129C11.7198 1.04083 11.7198 1.44566 11.4696 1.69533L6.28165 6.87274C6.03144 7.12242 5.62579 7.12242 5.37558 6.87274Z' fill='black'/> {/* eslint-disable-line */}
    </svg>
  );
}
